import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import Logo from '@/components/Logo';
import Menu from '@/icons/menu.svg';

import { SidebarMobile } from './Menu';

function Header() {
	const { t } = useTranslation();
	const [sidebarOpen, setSidebarOpen] = useState(false);

	return (
		<>
			<header className="fixed z-20 w-full bg-black">
				<div className="flex h-[52px] items-center justify-between px-5 lg:h-[72px] lg:px-6">
					<Logo />

					<Button
						variant="ghost"
						size="icon"
						className="inline-flex p-2 text-white lg:hidden lg:lacks-hover:block"
						onClick={() => setSidebarOpen(true)}
						aria-label={t('labels.menu')}
					>
						<Menu />
					</Button>
				</div>
			</header>
			<div className="h-[52px] lg:h-[72px]" />

			<SidebarMobile open={sidebarOpen} onChange={setSidebarOpen} />
		</>
	);
}

export default Header;
